import React from "react";
import { DownType, PatDownType } from "@prestosports/prestostats-core/Football";
import { GlobalHotKeys } from "react-hotkeys";
import Grid from "@material-ui/core/Grid";
import CardButton from "../CardButton";
import selectorStyles from "./styles/SelectorStyles";
import IndexedKeyListener from "../listeners/IndexedKeyListener";

const PenaltyDownTypeSelector = ({
	selected = {},
	onSelected,
	disableKeyListener,
	isPat = false
}) => {
	const classes = selectorStyles();
	const downtypes = Object.values(isPat ? PatDownType : DownType).sort((a, b) =>
		a.name.localeCompare(b.name)
	);

	const handleSkip = (e) => {
		e.preventDefault();
		if (selected.code) {
			const match = downtypes.find((p) => p.code === selected.code);
			if (match) onSelected(match);
		}
	};

	return (
		<Grid container spacing={1} justifyContent="flex-start">
			{downtypes.map((p, i) => (
				<Grid item xs={12} sm={3} key={p.code}>
					<CardButton
						size="small"
						textAlign="center"
						text={
							<span>
								<span className={classes.hotkey}>{i + 1}</span> {p.name}
							</span>
						}
						onClick={() => onSelected(p)}
						active={selected.code === p.code}
						id={p.name.toLowerCase().replace(" ", "-")}
					/>
				</Grid>
			))}
			<Grid item xs={12}>
				{!disableKeyListener && (
					<>
						<IndexedKeyListener
							arr={downtypes}
							onSelected={onSelected}
							type="Down Type"
						/>
						{selected.code && (
							<GlobalHotKeys
								keyMap={{ SKIP: ["tab"] }}
								handlers={{ SKIP: handleSkip }}
								allowChanges
							/>
						)}
					</>
				)}
			</Grid>
		</Grid>
	);
};

export default PenaltyDownTypeSelector;
